const LOAD_MS = 10_000;
const LOAD_FAILED = 'The report form could not load. Reload the page and try again.';
const copyLog = (log) => (Array.isArray(log) ? log.slice() : log);

/**
 * The report dialog without its code: ReportPanel loads on the first open(). The reporting context is
 * read at the click (report.js owns one immutable context per open; it must start here, not when the
 * chunk lands). An open while loading is ignored, close() cancels a pending open, and a failed or
 * hung import is told through onFlash. The next open() imports again, which can help after a timeout,
 * but Chromium keeps a failed import until the page reloads, so the message asks for a reload.
 */
export function createLazyReportPanel(options, load = () => import('./report.js')) {
  let panel = null;
  let pending = null;
  return {
    open(context = null) {
      if (panel) { panel.open(context); return; }
      if (pending) return;
      const attempt = pending = {};
      const snapshot = {
        ...context,
        roomCode: context?.roomCode ?? options.getRoomCode?.() ?? '',
        players: copyLog(context?.players ?? options.getPlayers?.() ?? []),
        chatLog: copyLog(context?.chatLog ?? options.getChatLog?.() ?? []),
        voiceLog: copyLog(context?.voiceLog ?? options.getVoiceLog?.() ?? []),
      };
      const fail = () => {
        clearTimeout(timer);
        if (pending !== attempt) return;
        pending = null;
        options.onFlash?.(LOAD_FAILED);
      };
      const timer = setTimeout(fail, LOAD_MS);
      new Promise((resolve) => { resolve(load()); }).then(({ ReportPanel }) => {
        clearTimeout(timer);
        panel ??= new ReportPanel(options);
        if (pending !== attempt) return;
        panel.open(snapshot);
        pending = null;
      }).catch(fail);
    },
    close() {
      if (panel) panel.close(); else pending = null;
    },
  };
}
